import React, { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

interface Props extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  src: any;
  alt: string;
}

export const SvgImage = ({ loading = 'lazy', ...props }: Props) => <img {...props} alt={props.alt} loading={loading} />;
